import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2772da35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen screen-overlay" }
const _hoisted_2 = { class: "instructions" }
const _hoisted_3 = { class: "instructions-message" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" On your phone, tablet, or computer,")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "room-code" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "room-code-label" }, "Enter Room Code", -1))
const _hoisted_8 = { class: "room-code-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createTextVNode(" go to " + _toDisplayString(_ctx.url), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.session.roomCode), 1)
      ]),
      _createElementVNode("button", {
        class: "start btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startGame && _ctx.startGame(...args)))
      }, "Everyone's Here")
    ])
  ]))
}